import { CurrencyOption } from '@/types/currency'
import { PaymentStatus, QuoteStatus } from './status'

export interface PaymentSummary {
  uuid: string
  merchantDisplayName: string
  merchantId: string
  dateCreated: number
  expiryDate: number
  quoteExpiryDate: number
  acceptanceExpiryDate: number
  quoteStatus: QuoteStatus
  reference: string
  type: string
  subType: string
  status: PaymentStatus
  displayCurrency: CurrencySummary
  walletCurrency: CurrencySummary
  paidCurrency: CurrencySummary
  networkFeeCurrency: CurrencySummary
  networkFeeRates: NetworkFeeRate[]
  feeCurrency?: CurrencySummary
  displayRate: RateSummary
  exchangeRate: RateSummary
  address: AddressSummary
  redirectUrl: string
  returnUrl: string
  transactions: TransactionSummary[]
  refund?: PaymentSummary | null
  refunds: []
  currencyOptions?: CurrencyOption[]
  flow: TransactionFlowType
  networkFeeBilledTo: CustomerType
  processingFeeBilledTo: CustomerType
  statusCode?: number
  customerId?: string
  walletId?: string
  twoStep?: boolean
  pegged?: boolean
  pegStablecoinDetails?: {
    paidCurrency: CurrencySummary
    pegRateAdjustmentFee: CurrencySummary
    exchangeRate: RateSummary
  }
  accountId?: string
  userId?: string
}

export interface AddressSummary {
  protocol: string
  address: string
  tag: null
  uri: string
  alternatives: []
}

export interface CurrencySummary {
  currency: string
  amount: number
  actual: number
}

export interface NetworkFeeRate {
  currency: string
  network: string
  amount: number
}

export interface RateSummary {
  base: string
  counter: string
  rate: number
}

interface TransactionSummary {
  dateCreated: number
  dateConfirmed: number | null
  hash: string
  amount: number
  risk: RiskSummary | null
  networkFeeCurrency: null | string
  networkFeeAmount: null | number
  sources: null | string[]
  exchangeRate: RateSummary | null
  displayRate: RateSummary | null
}

interface RiskSummary {
  level: string
  resourceName: string | null
  resourceCategory: number | null
}

export const Flow = {
  IN: 'PayIn',
  OUT: 'PayOut',
  CHANNEL: 'Channel',
}

export type FlowType = (typeof Flow)[keyof typeof Flow]

export const PaymentType = {
  QR_CODE: 'QR_CODE',
  CONNECT_KIT: 'CONNECT_KIT',
} as const

export const PaymentSubType = {
  HELD_DEPOSIT_REFUND: 'heldDepositRefund',
  MERCHANT_REFUND: 'merchantRefund',
} as const

export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType]

export interface Token {
  token: string
}

export const TransactionFlow = {
  PAYROLL: 'PAYROLL',
  DEFAULT: 'DEFAULT',
} as const

export type TransactionFlowType = (typeof TransactionFlow)[keyof typeof TransactionFlow]

export const CustomerType = {
  MERCHANT: 'MERCHANT',
  USER: 'USER',
} as const

export type CustomerType = (typeof CustomerType)[keyof typeof CustomerType]
